export const MARKETS = [
  { id: 1, name: 'Randstad-Noord', abbreviation: 'Noord' },
  { id: 2, name: 'Randstad-Zuid', abbreviation: 'Zuid' },
  { id: 3, name: 'Eindhoven', abbreviation: 'Oost' },
] as const
